import { FeedbackOutlined } from '@mui/icons-material'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box
} from '@mui/material'
import { Type } from 'apache-arrow'
import ButtonBase from 'design-system/button'
import { TranscriptionInput } from 'design-system/input'

interface FeedbackDialogProps {
  open: boolean
  onClose: () => void
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSave: () => void
  hasChanged: boolean
  isSaving?: boolean
}

export const FeedbackDialog = ({
  open,
  onClose,
  value,
  onChange,
  onSave,
  hasChanged,
  isSaving = false
}: FeedbackDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        <Typography
          variant='h6'
          component='div'
          display='flex'
          alignItems='center'
        >
          <FeedbackOutlined sx={{ mr: 1 }} /> Comentário técnico para a equipe
          da sentinela
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='textSecondary'>
          Este comentário será utilizado para melhorar o modelo de análise da
          sentinela. Ele será visível apenas para a equipe técnica da sentinela
          e não influenciará o resultado da análise atual.
        </Typography>
        <Box sx={{ pt: 1 }}>
          <TranscriptionInput
            value={value}
            onChange={onChange}
            placeholder='Digite o comentário técnico para a equipe da sentinela...'
            rows={6}
          />
          {hasChanged && (
            <Typography
              variant='caption'
              color='warning.main'
              sx={{ mt: 1, display: 'block' }}
            >
              * Alterações não salvas
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <ButtonBase onClick={onClose} variant='outlined' disabled={isSaving}>
          Cancelar
        </ButtonBase>
        <ButtonBase onClick={onSave} disabled={!hasChanged || isSaving}>
          {isSaving ? 'Salvando...' : 'Salvar feedback'}
        </ButtonBase>
      </DialogActions>
    </Dialog>
  )
}
